import { Component } from '@angular/core';

@Component({
  selector: 'mprd-data-boost-skeleton',
  templateUrl: './data-boost-skeleton.component.html',
})
export class DataBoostSkeletonComponent {
  constructor() {}
}
